import OnScreen from 'onscreen';

const $ = jQuery;
const $window = $(window);

const initVideo = () => {
  const els = once('video-display', '.p-video-display');
  els.forEach((el) => {
    const $this = $(el);
    const $videoWrapper = $this.find('.pvd-video');
    const $videoThumbnail = $videoWrapper.find('.pvd-preview');
    const $playBtn = $videoWrapper.find('.pvd-playbtn');
    const $iframeObj = $videoWrapper.find('#pvd-embed');
    const $embedSrc = $iframeObj.attr('src');

    const url = new URL($embedSrc);

    const playVideo = (isMuted) => {
      if (isMuted) {
        url.searchParams.set('muted', '1');
      }
      url.searchParams.set('autoplay', '1');
      $iframeObj.attr('src', url.toString());
      $this.addClass('om-started');
      $videoThumbnail.hide();
      $playBtn.hide();
    };

    if ($this.hasClass('p-video-display--full_width')) {
      $videoThumbnail.hide();
      $playBtn.hide();
      const os = new OnScreen({
        tolerance: Math.round($videoWrapper.height() / 2),
        debounce: 0,
      });
      os.on('enter', '#pvd-embed', function () {
        if (!$this.hasClass('om-started')) {
          playVideo(true);
        }
      });
    } else {
      // Set autoplay to '0' on load, incase link comes with autoplay
      url.searchParams.set('autoplay', '0');
      $iframeObj.attr('src', url.toString());
    }

    // Show and autoplay video on play button click
    $playBtn.click(() => playVideo(false));
  });
};

$window.on('load', () => initVideo());
